import { useEffect } from 'react';

const APP_NAME = 'Solimat · Portal Pacientes';

/**
 * Sets the browser tab title for the current page.
 * Usage: usePageTitle('Mis Citas')  →  "Mis Citas | Solimat · Portal Pacientes"
 */
const usePageTitle = (pageTitle: string): void => {
  useEffect(() => {
    const prev = document.title;
    document.title = `${pageTitle} | ${APP_NAME}`;
    return () => {
      document.title = prev;
    };
  }, [pageTitle]);
};

export default usePageTitle;
